import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardActionArea,
  Typography,
  Grid,
  Container,
  IconButton,
  Box,
  Divider,
  Breadcrumbs,
  Link
} from '@mui/material';
import { Home as HomeIcon, ChevronRight } from '@mui/icons-material';
import * as Icons from '@mui/icons-material';

// Array di configurazione per gli elementi del menu con descrizioni
const menuItems = [
  {
    label: 'Catalogo Prodotti',
    description: 'Visualizza, modifica e aggiungi nuovi prodotti al catalogo',
    icon: 'Storefront',
    path: '/techyshop/products',
    color: '#ff9800',
  },
  {
    label: 'Attributi Prodotti',
    description: 'Gestisci le caratteristiche e varianti dei prodotti',
    icon: 'ListAlt',
    path: '/techyshop/attributes',
    color: '#03a9f4',
  },
  {
    label: 'Categorie Prodotto',
    description: 'Organizza i prodotti in categorie e sottocategorie',
    icon: 'Category',
    path: '/techyshop/categories',
    color: '#e91e63',
  },
  {
    label: 'Gestione Traduzioni',
    description: 'Configura le lingue e i testi per lo shop online',
    icon: 'Translate',
    path: '/techyshop/translations',
    color: '#3f51b5',
  },
  {
    label: 'Gestione Utenti',
    description: 'Controlla gli accessi e i profili dei clienti techyshop',
    icon: 'Group',
    path: '/techyshop/users',
    color: '#4caf50',
  },
  {
    label: 'Gestione Banners',
    description: 'Personalizza i banner promozionali e le offerte dello shop',
    icon: 'ViewCarousel',
    path: '/techyshop/banners',
    color: '#9c27b0',
  },
  {
    label: 'Gestione Menu',
    description: 'Configura le voci del menu di navigazione dello shop',
    icon: 'Menu',
    path: '/techyshop/menu',
    color: '#f44336',
  },
  {
    label: 'Gestione Media',
    description: 'Gestisci file multimediali, immagini e gallerie dello shop',
    icon: 'PermMedia',
    path: '/techyshop/media',
    color: '#00bcd4',
  },
  {
    label: 'Vai allo Shop',
    description: 'Apri l\'interfaccia pubblica in una nuova scheda',
    icon: 'OpenInNew',
    action: () => window.open('https://techyshop.techysumo.it', '_blank'),
    color: '#009688',
  }
];

function Techyshop() {
  const navigate = useNavigate();

  const handleAction = (item) => {
    if (item.action) {
      item.action();
    } else if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {/* Breadcrumbs & Navigation */}
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Breadcrumbs
          separator={<ChevronRight fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ color: 'rgba(255,255,255,0.7)' }}
        >
          <Link
            underline="hover"
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: 'inherit' }}
            onClick={() => navigate('/')}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </Link>
          <Typography color="primary.main" sx={{ fontWeight: 600 }}>TechyShop</Typography>
        </Breadcrumbs>

        <IconButton color="primary" onClick={() => navigate('/')} sx={{ border: '1px solid', borderColor: 'primary.main' }}>
          <HomeIcon />
        </IconButton>
      </Box>

      {/* Header Section */}
      <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 800 }}>
        Techy<Box component="span" sx={{ color: 'primary.main' }}>Shop</Box>
      </Typography>

      <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, px: 1 }}>
        Strumenti di Gestione
      </Typography>

      <Grid container spacing={3}>
        {menuItems.map((item, index) => {
          const IconComponent = Icons[item.icon] || Icons.HelpOutline;
          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderLeft: `4px solid ${item.color}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    boxShadow: `0 8px 20px rgba(0,0,0,0.3), 0 0 10px ${item.color}33`,
                  }
                }}
              >
                <CardActionArea
                  onClick={() => handleAction(item)}
                  sx={{ height: '100%', p: 3, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                >
                  <Box sx={{
                    p: 1.5,
                    borderRadius: 3,
                    backgroundColor: `${item.color}22`,
                    color: item.color,
                    mb: 2
                  }}>
                    <IconComponent sx={{ fontSize: 32 }} />
                  </Box>

                  <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1, color: 'white' }}>
                    {item.label}
                  </Typography>

                  <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>
                    {item.description}
                  </Typography>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Box sx={{ mt: 8 }}>
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mb: 3 }} />
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.4)', textAlign: 'center' }}>
          Sistema integrato TechySumo • Ultimo aggiornamento: Marzo 2026
        </Typography>
      </Box>
    </Container>
  );
}

export default Techyshop;
